module.exports = __webpack_public_path__ + "static/floor_preview__1-2-aa1d33cc48ee38ecc61a1d0ce1af90b4.png";